import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { S3 } from "../awsConfig";
import { MODAL_LOADER } from "../actions/types";
import { axiosInstance, updatedAccessToken } from "../api";
import {
  ERROR,
  GET_CUSTOMER_STATUS_FAULT_SUCCESS,
  GET_CUSTOMER_STATUS_FAULT,
  LOADER,
  GET_CUSTOMER_FAULT_IMAGE,
  GET_CUSTOMER_FAULT_IMAGE_SUCCESS,
  GET_CUSTOMER_FAULT_IMAGE_FAILED,
  GET_CUSTOMER_STATUS_FAULT_FAILED,
  TOKEN_EXPIRED,
} from "../actions/types";

let bucketName = process.env.REACT_APP_BUCKET_NAME;

function getCustomerFaultApi(action) {
  let apiUrl1 = `reportsearch?searchStr=${action.payload.searchText}&pagenumber=${action.payload.page}&tab=${action.payload.tab}&order=${action.payload.order}&columnname=${action.payload.columnname}&is_archive=${action.payload.is_archive}&report_id=${action.payload.reportId}`;
  return axiosInstance.get(apiUrl1, { headers: updatedAccessToken() });
}

async function getCustomerFaultImage(action) {
  const objects = await S3.listObjects({
    Bucket: bucketName,
    Prefix: action.payload,
  }).promise();

  return Promise.all(
    objects.Contents.map(
      async (t) =>
        await S3.getSignedUrl("getObject", { Key: t.Key, Expires: 10000 })
    )
  ).then((photoUrls) => { console.log(photoUrls, '==photoUrlsaction.payload', action.payload) 
  return photoUrls?.[0] || "";
 });
}

function* customerFaultApi(action) {
  try {
    const response = yield call(() => getCustomerFaultApi(action));
    if (response?.data?.statusCode === 200) {
      yield put({
        type: GET_CUSTOMER_STATUS_FAULT_SUCCESS,
        response: response.data,
      });
    } else {
      yield put({
        type: LOADER,
        payload: false,
      });
      yield put({
        type: ERROR,
        payload: response.data.body.message,
      });
    }
  } catch (err) {
    if (err.response?.status === 403) {
      yield put({
        type: TOKEN_EXPIRED,
        payload: true,
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      yield put({
        type: ERROR,
        payload: err.message,
      });
    }

    yield put({
      type: GET_CUSTOMER_STATUS_FAULT_FAILED,
      payload: err.message,
    });

    yield put({
      type: LOADER,
      payload: false,
    });
  }
}

function* customerFaultImage(action) {
  try {
    const photoUrl = yield call(
      async () => await getCustomerFaultImage(action)
    );
    console.log(photoUrl, 'photoUrlcustomerFaultImage')

    yield put({ type: MODAL_LOADER, payload: false });
    yield put({ type: GET_CUSTOMER_FAULT_IMAGE_SUCCESS, response: photoUrl });
  } catch (e) {
    if (encodeURI.response?.status === 403) {
      yield put({
        type: TOKEN_EXPIRED,
        payload: true,
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      yield put({ type: GET_CUSTOMER_FAULT_IMAGE_FAILED, message: e.message });
    }
    yield put({ type: MODAL_LOADER, payload: false });
  }
}

function* customerFault() {
  yield takeLatest(GET_CUSTOMER_STATUS_FAULT, customerFaultApi);
}

function* customerFaultImage1() {
  yield takeLatest(GET_CUSTOMER_FAULT_IMAGE, customerFaultImage);
}

const sagaFunc = {
  customerFault: customerFault(),
  customerFaultImage1: customerFaultImage1(),
};

export default sagaFunc;
